import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {IVersionDetails} from "../../versiont.details/interfaces/version.details";
import {VersionDetailsService} from "../../versiont.details/services/version.details.service";
import {ProductLabelingState} from "../../versiont.details/interfaces/product.labeling.state";

@Component({
  selector: 'app-about-page',
  templateUrl: './about.page.template.html',
  styleUrls: ['./about.page.style.scss']
})
export class AboutPageComponent implements OnInit{

  @Output() close = new EventEmitter();

  public productName = 'Philips Radiology Information System';
  public buildYear: number;
  public commercialVersion: string;
  public internalVersion: string;
  public commonVersion: string;
  public productCodeNumber = 839007;
  public buildDate: string;
  public buildDateUDI: string;
  public acknowledgement3rdUrl: string;
  public isUnreleasedDevice: boolean;
  public isNonMedicalDevice: boolean;

  public resources = {
    images: {
      philips: require("./assets/philips.png"),
      cautionSymbol:  require("./assets/caution.png"),
      consultSymbol:  require("./assets/consult.png"),
      manufacturerSymbol:  require("./assets/manufacture.png"),
      manufacturerDateSymbol:  require("./assets/manufacture-date.png")
    }
  };

  constructor(private versionDetailsService: VersionDetailsService) {
  }

  ngOnInit(): void {

    const versionDetails: IVersionDetails =  this.versionDetailsService.getVersionDetails();

    this.buildYear = versionDetails.buildDate.getFullYear();
    this.commercialVersion = versionDetails.commercialVersion;
    this.internalVersion = versionDetails.internalVersion;
    this.buildDate =   this.getFormattedBuildDate(versionDetails.buildDate);
    this.buildDateUDI = this.getFormattedBuildDateUDI(versionDetails.buildDate);
    this.commonVersion = versionDetails.commercialVersion.split('.')[0];

    if (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice) {
      this.productName += " (WIP)";
    }

    this.isUnreleasedDevice = (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice);
    this.isNonMedicalDevice = (versionDetails.productLabelingState !== ProductLabelingState.ReleasedMedicalDevice);
  }

  private getFormattedBuildDate(buildDate: Date): string {
    return buildDate.getFullYear() + "-"
      +  this.padDatePart(buildDate.getMonth() + 1) + "-"
      + this.padDatePart(buildDate.getDate());
  }

  private getFormattedBuildDateUDI(buildDate: Date): string {
    const year = buildDate.getFullYear().toString().substr(2);
    const month = this.padDatePart(buildDate.getMonth() + 1);
    const day = this.padDatePart(buildDate.getDate());

    return year + month + day;
  }

  private padDatePart(datePart: number) {

    const datePartStr = datePart.toString();
    if (datePartStr.length === 1){
      return "0" + datePartStr;
    }
    return datePartStr;
  }

}
